
/* eslint-disable */
import { viagemStore, mainStore, userToolStore, departureStore } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import { IDeparture } from '@/interfaces/departure';
// Trecho abaixo, faz ignorar todos os Vue warn no console do navegador

// const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
// Vue.config.warnHandler = function (msg:any, vm:any, trace:any) {
//   // `trace` is the component hierarchy trace
//   if (msg === ignoreWarnMessage) {
//     msg = null;
//     vm = null;
//     trace = null;
//   }
// }

// Vue warn causado pelo 'v-calendar' -> bug do Vue
import ShowGrade from './ShowGrade.vue';
import ShowCronograma from './ShowCronograma.vue';
import ShowViagens from '@/views/main/gestaoViagem/ShowViagens.vue';

@Component({
  components: {
    ShowGrade,
    ShowCronograma,
    ShowViagens,
  },
})
export default class CalendarioList extends Vue {
  public focus = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }).toString();

  public tool = {};

  public selectedOpen = false;

  public selectedElement = null;

  public selectedEvent = {};

  public type = 'month';

  public weekday = [1, 2, 3, 4, 5, 6, 0];

  public viagens = [] as any;

  public mode = 'stack';

  public loadingCalendar = false;

  public allowCreate = false;

  public allowDelete = false;

  public selectedDeparture: IDeparture = { id: 0, name: 'Todos', description: '' };

  get userProfile() {
    return mainStore.userProfile;
  }

  get userTools() {
    return userToolStore.userTools;
  }

  public get departures() {
    let arr = [];
    //@ts-ignore
    arr = departureStore.departures;
    //@ts-ignore
    arr.unshift({ id: 0, name: 'Todos' });
    return arr;
  }

  public eventMore(obj) {
    const data = obj.date;
    let form: any = this.$refs.showViagens;
    form.show(data);
  }

  public getEventTitle(event) {
    if (event.start) {
      let title = event.name;

      if (event.start.substr(11, 5) != '') {
        title = title + ' ' + event.start.substr(11, 5);
      }

      if (event.end.substr(11, 5) != '') {
        title = title + ' - ' + event.end.substr(11, 5);
      }
      return title;
    }
  }

  public getEventColor(event) {
    return event.color;
  }

  public async showGrade() {
    let form: any = this.$refs.showGrade;
    form.show();
  }

  public async showCronograma() {
    let form: any = this.$refs.showCronograma;
    form.show();
  }

  public convert(current_datetime) {
    let formatted_date =
      current_datetime.getFullYear() +
      '-' +
      (current_datetime.getMonth() + 1) +
      '-' +
      current_datetime.getDate() +
      ' ' +
      current_datetime.getHours() +
      ':' +
      current_datetime.getMinutes() +
      ':' +
      current_datetime.getSeconds();
    return formatted_date;
  }

  public async showInfo() {
    //@ts-ignore
    const viagem: IViagem = await viagemStore.getViagem(this.selectedEvent.id);
    const id: string = viagem.id;

    this.$router.push({
      name: 'main-gestao-viagem-edit',
      params: { id: id, isReadOnly: 'true' },
    });
  }

  public showFiltroPorTabela() {
    let form: any = this.$refs.filtroPorTabela;
    form.show('viagem');
  }

  public async filtrar() {
    this.loadingCalendar = true;
    const departureId = this.selectedDeparture.id;

    this.viagens = await viagemStore.getViagemCalendarioFiltered(departureId);
    this.loadingCalendar = false;
  }

  public showEvent({ nativeEvent, event }) {
    const open = () => {
      (this.selectedEvent = event),
        (this.selectedElement = nativeEvent.target),
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
    };

    if (this.selectedOpen) {
      this.selectedOpen = false;
      setTimeout(open, 10);
    } else {
      open();
    }

    nativeEvent.stopPropagation();
  }

  public openEventLink() {
    window.open('//' + this.selectedEvent['link']);
  }

  public async mounted() {
    this.loadingCalendar = true;
    userToolStore.currentUserTools.forEach((item) => {
      if (item.tool_id == 11) {
        this.allowDelete = item.allow_delete;
        this.allowCreate = item.allow_create;
      }
    });
    this.viagens = await viagemStore.getVI();
    this.loadingCalendar = false;
  }
}
